import React from 'react'
import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min'
import 'jquery.maskedinput/src/jquery.maskedinput'
import Input from './Input.jsx'
import PropTypes from 'prop-types'
import { DATE_TIME_FORMAT, dateTimeFormatToIsoDateTime } from '../../services/utils/dateTime'
import { getLang } from '../../gettext/utils'

const DEFAULT_MIN_DATE = '01.01.1900'
const DEFAULT_MAX_DATE = '01.01.3000'

export default class DateTimeInput extends Input {
  inputGroupRef = React.createRef()

  static propTypes = {
    format: PropTypes.string,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    pickerMask: PropTypes.string,
    className: PropTypes.string,
  }

  static defaultProps = {
    format: DATE_TIME_FORMAT,
    minDate: DEFAULT_MIN_DATE,
    maxDate: DEFAULT_MAX_DATE,
    pickerMask: '99.99.9999 99:99',
    className: 'input-group'
  }

  getPickerElement () {
    return $(this.inputGroupRef.current)
  }

  setPickerMask () {
    $('input', this.getPickerElement()).mask(this.props.pickerMask)
  }

  setCalendarDate (method, value, fallback) {
    const setter = this.getPickerElement().data('DateTimePicker')[method]
    if (typeof setter !== 'function') return

    try {
      setter(value || fallback)
    } catch {
      setter(fallback)
    }
  }

  componentDidMount () {
    // minDate and maxDate has to be converted to isoDate to initialize correctly
    const datepickerOptions = {
      format: this.props.format,
      minDate: dateTimeFormatToIsoDateTime(this.props.minDate || DEFAULT_MIN_DATE),
      maxDate: dateTimeFormatToIsoDateTime(this.props.maxDate || DEFAULT_MAX_DATE),
      sideBySide: true,
      useCurrent: false,
      locale: getLang(),
      keyBinds: null,
      icons: {
        up: 'fal fa-chevron-up',
        down: 'fal fa-chevron-down',
        previous: 'fal fa-chevron-left',
        next: 'fal fa-chevron-right',
      },
    }

    this.getPickerElement()
      .datetimepicker(datepickerOptions)
      .on('dp.change', (date) => {
        const newValue = date.date ? date.date.format(this.props.format) : ''
        this.props.onChange(this.props.name, newValue)
        this.setPickerMask()
      })

    this.setPickerMask()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.minDate !== this.props.minDate) {
      this.setCalendarDate('minDate', this.props.minDate, DEFAULT_MIN_DATE)
    }

    if (prevProps.maxDate !== this.props.maxDate) {
      this.setCalendarDate('maxDate', this.props.maxDate, DEFAULT_MAX_DATE)
    }
  }

  render () {
    return (
      <div className={this.props.className} ref={this.inputGroupRef}>
        <input
          type="text"
          name={this.props.name}
          placeholder={this.props.placeholder}
          value={this.props.value}
          onChange={this.handleChange}
          className="form-control datetime-control border-input rounded-left"
          disabled={this.props.disabled}
          autoComplete="off"
          data-parsley-required={this.props.required}
          data-parsley-errors-messages-disabled
        />
        <span className="input-group-append datepickerbutton">
          <span className="input-group-text">
            <span className="fal fa-calendar-alt"/>
          </span>
        </span>
      </div>
    )
  }
}
